/**
 * IndexedDB Handler / Adapter
 */

// This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB

let db = { version: 0 }

export const exists = json => new Promise ( resolve => {
    let connection = indexedDB.open("OrthupData")
    connection.onsuccess = event => {
        db = connection.result
        let result = connection.result.objectStoreNames.contains(json.sk)
        db.close()
        resolve(result)
    }
})

export const createProjectEntry = (json, data) => {
    return new Promise ( resolve => {
        let connection = indexedDB.open("OrthupData", db.version+1)
        connection.onupgradeneeded = event => {
            db = connection.result
            var store = db.createObjectStore(json.sk, {keyPath: "id"})
            store.put({
                id: json.Reference.hash, 
                createdAt: json.Reference.creationDate, 
                storedAt: Date.now(), 
                data: data,
                format: json.Reference.format,
                sequence: json.Reference.sequence
            })
            resolve( db.close() )
        }
    })
}

export const removeStore = index => new Promise ( resolve => {
    let connection = indexedDB.open("OrthupData", db.version+1)
    connection.onupgradeneeded = () => {
        db = connection.result
        db.deleteObjectStore(index)
        resolve(db.close())
    }  
})

export const retrieveBlob = props => new Promise ( resolve => {
    let connection = indexedDB.open('OrthupData')
    connection.onsuccess = () => {
        db = connection.result
        db.transaction(props.project.store)
            .objectStore(props.project.store)
            .get(props.project.hash)
            .onsuccess = event => {
                let result = (typeof event.target.result !== 'undefined') ? event.target.result.data : { size: 0 }
                db.close()
                resolve(result)
            }
    }  
})

export const cleanStores = () => {
    let connection = indexedDB.open("OrthupData"),
        meta = {
            id: 0,
            date: Date.now()
        }
    connection.onsuccess = event => {
        db = connection.result
        let stores = db.objectStoreNames
        if(stores.length > 3){
            Object.values(stores).forEach( (storekey,i,array) => {
                db.transaction(storekey)
                .objectStore(storekey)
                .getAll()
                .onsuccess = event => {
                    if( meta.date > event.target.result[0].storedAt ){
                        meta = {
                            id: storekey,
                            date: event.target.result[0].storedAt
                        }
                    }
                    if ( i === array.length - 1 ){ 
                        removeStore(meta.id)
                    }

                }
            })
        }
        db.close()
    }
}
